import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const allowedTypes = [
  'text',
  'break',
  'paragraph',
  'emphasis',
  'strong',
  'thematicBreak',
  'blockquote',
  'link',
  'linkReference',
  'list',
  'listItem',
  'heading',
];

const MarkdownRender = ({ value }) => (
  <ReactMarkdown
    linkTarget="_blank"
    skipHtml
    allowedTypes={allowedTypes}
    remarkPlugins={[remarkGfm]}
  >
    {value}
  </ReactMarkdown>
);
export default MarkdownRender;
